module.exports = __webpack_public_path__ + "2e8fcfff357181ae118cf7e5712546fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-short-answer-in-only.png
// module id = 1117
// module chunks = 0